import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Get all my companies part of
export const getAllMyCompanies = createAsyncThunk(
  "company/getAllMyCompanies",
  async () => {
      const response = await api.get("/user/my-companies");
      console.log("Companies fetched:", response.data);
      return response.data;
  }
);

// Get specific company profile (requires membership)
export const getSpecificCompanyProfile = createAsyncThunk(
  "company/getSpecificCompanyProfile",
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/user/companies/${companyId}/profile`);
      console.log("Specific company profile fetched:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error fetching specific company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch specific company profile");
    }
  }
);

// Get My own company profile
export const getCompanyProfile = createAsyncThunk(
  "company/getCompanyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/user/company-profile");
      console.log("Company profile fetched:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error fetching company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch company profile");
    }
  }
);

// Update company profile
export const updateCompanyProfile = createAsyncThunk(
  "company/updateCompanyProfile",
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await api.put("/user/company-profile", companyData);
      console.log("Company profile updated:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error updating company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to update company profile");
    }
  }
);
